import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import { PopOutIcon } from '../shared/PopOutIcon';
import * as CalendarActions from '../../actions/calendar';
import { changeAlertText } from '../../actions';
import './AssociateAttendee.scss';
import { useSelector, useDispatch, batch } from 'react-redux';

export const AssociateAttendee = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const objectsAndDisplayFields = useSelector((state) => state.mail.settings?.calendarSettings?.attendeeDisplayFields);
  const associateContactObject = useSelector((state) => state.calendar.contactListObject);
  const selectedContacts = useSelector((state) => state.calendar.selectedContacts);
  const multipleMatchedContacts = useSelector((state) => state.calendar.multipleMatchedContacts);

  const email = associateContactObject.email;
  const contactList = associateContactObject.contactList;
  const isOrganizer = associateContactObject.isOrganizer;

  const getDisplayFields = (objectApiName) => {
    return objectsAndDisplayFields?.find((object) => object.objectApiName === objectApiName)?.displayFields.map((field) => field.apiName) || [];
  };

  const selectContact = (contact) => {
    if (!isOrganizer) {
      selectedContacts[contact.emailAddress] = contact;
      delete multipleMatchedContacts[contact.emailAddress];

      batch(() => {
        dispatch(CalendarActions.setSelectedContacts(selectedContacts));
        dispatch(CalendarActions.setMatchedContacts(multipleMatchedContacts));
        dispatch(CalendarActions.cancelSelectContact());
        dispatch(CalendarActions.attendeeChange());
        dispatch(changeAlertText('1 user successfully added'));
      });
    } else {
      batch(() => {
        dispatch(CalendarActions.selectOrganizer(contact));
        dispatch(CalendarActions.attendeeChange());
        dispatch(changeAlertText('1 user successfully added'));
      });
    }
  };

  const cancelSelectContact = () => {
    dispatch(CalendarActions.cancelSelectContact());
  };

  return (
    <div className='associateAttendee'>
      <div className='associateAttendee-nav'>
        <span id="link" onClick={() => cancelSelectContact()}>
          <Svg className='associateAttendee-nav-image' data='/assets/chevronleft.svg' />
          <span className='associateAttendee-nav-text'>Back</span>
        </span>
      </div>
      <div className='associateAttendee-titleCard'>
        <div className='associateAttendee-titleCard-details'>
          <h2>{contactList.length} Matching { isOrganizer ? 'Users' : 'Attendees' } Found</h2>
          <p>{email} {isOrganizer && <span>(Assigned To)</span>}</p>
        </div>
      </div>
      <div className='associateAttendee-contactList'>
        {
          contactList.map((attendee) => (
            <div key={attendee.id} className='associateAttendee-contact' >
              <Svg className='associateAttendee-image' data={ isOrganizer || attendee.objectApiName === 'User' ? '/assets/people.svg' : '/assets/contact.svg' }/>
              <div className='associateAttendee-details'>
                <h2>{attendee.displayFields[getDisplayFields(attendee.objectApiName)[0]]} { attendee.isOrganizer && <span>(Assigned to)</span> }</h2>
                {
                  getDisplayFields(attendee.objectApiName)?.slice(1)?.map((currentDisplayField, index) => {
                    return (<p key={index}>{attendee.displayFields[currentDisplayField]}</p>);
                  })
                }
              </div>
              <PopOutIcon className='associateAttendee-contact-popOutIcon' link={`${user.salesforceInstanceUrl}/lightning/r/${attendee.objectApiName}/${attendee.objectId}/view`} />
              <Svg className='associateAttendee-contact-addIcon' data='/assets/plusSignActive.svg' onClickAction={() => selectContact(attendee)}/>
            </div>
          ))
        }
      </div>
    </div>
  );
};

AssociateAttendee.propTypes = {
  email: PropTypes.string,
  contactList: PropTypes.array,
  isOrganizer: PropTypes.bool,
};
